import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Route, Routes, Link } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Home } from './routes/Home'
import { NewDropbox } from './routes/New'
import { Recipient } from './routes/Recipient'
import { Admin } from './routes/Admin'
import { PageShell } from './components/ui'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Uploads and autosaves already invalidate explicitly; background refetch
      // would only fight with in-progress edits.
      refetchOnWindowFocus: false,
      staleTime: 5_000,
    },
  },
})

function NotFound() {
  return (
    <PageShell>
      <h1 className="text-2xl font-bold">Nothing here</h1>
      <p className="mt-2 text-zinc-600 dark:text-zinc-400">
        Check the link you were sent, or{' '}
        <Link to="/" className="text-brand-600 underline underline-offset-2">
          go to your dropboxes
        </Link>
        .
      </p>
    </PageShell>
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/new" element={<NewDropbox />} />
          <Route path="/d/:token" element={<Recipient />} />
          <Route path="/a/:token" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
